<template>
  <div class="contentOut">
    <div class="prov-total">
      <div class="prov-total-sel">
        <div class="select" @click="handleQuarterShow()">
          <span>{{ quarterName }}</span>
          <div class="select-icon"></div>
        </div>
        <titleTab :tabList="titleTab" @titletabChange="titletabChange"></titleTab>
      </div>
      <div class="content">
        <div class="content-pd16">
          <tab class="mt0" ref="drawer" :tabList="dataTab" :name="'dataTab'" @onSwitch="tabSwitch"></tab>
          <rankCharts
            v-if="ranking.length > 0"
            class="mt16"
            :rankList="ranking"
            :checked="checked"
          />
          <template v-else>
            <!-- 没有数据提示 -->
            <div class="noData-bg">
              <nodata :noData="noData"></nodata>
            </div>
          </template>
        </div>
        <div class="msg-div">
          <div v-for=" (item, index) in warning" :key="index">
            <messageBottom :msgType="'warning'" v-if="warning.length" :content="item"></messageBottom>
          </div>
          <messageBottom :msgType="'error'" v-if="accountability.length" :content="accountability"></messageBottom>
        </div>
      </div>
      <common-picker
        ref="commonPickerQuarter"
        :typeList="newQuarterList"
        :cols="cols1"
        @getTypeValue="getQuarterValue"
      ></common-picker>
    </div>
  </div>
</template>
<script>
import nodata from "./../components/nodata"; // 没有数据
import annoswiper from "./../components/anno-swiper";
import rankCharts from "./components/RankCharts";
import messageBottom from "./components/messageBottom";
import tab from "comps/tab";
import titleTab from "./components/titleTab";

import commonPicker from "../../../components/base/commonPicker";
import API from "../../../service/index";
import commonAPI from "../../../utils/common";
export default {
  components: {
    annoswiper,
    nodata,
    tab,
    rankCharts,
    titleTab,
    messageBottom,
    commonPicker,
  },
  data() {
    return {
      noData: {
        // 缺省组件展示信息
        title: "暂无数据",
      },
      quarterName: "", //
      yearQuarter: "",
      year: "",
      quarter: "2",
      computedQuarter: "",
      accountability_bool: false,
      accountability: [],
      warning_bool: false,
      warning: [],
      ranking: [],
      dataTab: [],
      checked: true,
      titleTab: ["一类地区", "二类地区"],
      titleTabindex: 0,
      temAuthority: null,
      newQuarterList: [],
      temSaveAllYear: [],
      cols1: 1,
    };
  },
  async created() {
    await this.getQuarters();
    //默认
    this.getScoreList(
      Number(this.quarterName.substring(0, 4)),
      commonAPI.fixquarter(this.dataTab[0]),
      1
    );
  },
  methods: {
    // 获取季度年份
    getQuarters() {
      return new Promise((resolve, reject) => {
        API.getQuarters({}).then((res) => {
          let temyearList = [];
          for (let i = 0; i < res.data.length; i++) {
            for (let key in res.data[i]) {
              let value = res.data[i][key];
              let year = value.substring(0, 5);
              let quarter = value.substring(5, value.length);
              let obj = {};
              obj["text"] = year;
              obj["quarter"] = quarter;
              obj["quarterindex"] = key.substring(5);
              this.temSaveAllYear.push(obj);
              temyearList.push(year);
            }
          }
          // console.log("-----年季度:", temyearList);
          if (temyearList && temyearList.length > 0) {
            temyearList = Array.from(new Set(temyearList)).reverse();
            let temarr = [];
            for (let i = 0; i < temyearList.length; i++) {
              let obj = { text: temyearList[i] };
              temarr.push(obj);
            }
            this.quarterName = temarr[0].text;
            this.choiceYear(temarr[0].text);
            this.newQuarterList = [temarr];
            resolve();
          }
          reject();
        });
      });
    },
    // 获取
    getScoreList(year, quarter, areaType) {
      API.getAssessScoreList({
        year: year,
        quarter: quarter,
        areaType: areaType,
      }).then((res) => {
        console.log("数据列表:", res.data);
        if (res.ret == 0) {
          if (res.data.scoreVOList) {
            this.ranking = [];
            this.ranking = res.data.scoreVOList.map((e) => ({
              area: e.area,
              areaName: e.areaName,
              diffRanking: e.diffRanking,
              oldRanking: e.oldRanking,
              quarter: e.quarter,
              ranking: e.ranking,
              score: e.score / 100,
              year: e.year,
            }));
          } else {
            this.ranking = [];
          }

          if (res.data.warning) {
            this.warning_bool = true;
            this.warning = res.data.warning;
          } else {
            this.warning_bool = false;
            this.warning = [];
          }
          if (res.data.accountability) {
            this.accountability_bool = true;
            this.accountability = res.data.accountability;
          } else {
            this.accountability_bool = false;
            this.accountability = "";
          }
        }
      });
    },
    choiceYear(text) {
      let temarr = [];
      if (this.temSaveAllYear && this.temSaveAllYear.length > 0) {
        for (let i = 0; i < this.temSaveAllYear.length; i++) {
          if (this.temSaveAllYear[i].text === text) {
            temarr.push(this.temSaveAllYear[i].quarter); //确定有多少个季度
          }
        }
      }
      this.dataTab = temarr.reverse();
      this.computedQuarter = commonAPI.fixquarter(this.dataTab[0]);
    },

    // 获取季度列表
    getQuarterValue(value) {
      // 选择年份
      this.quarterName = value[0].text;
      this.choiceYear(value[0].text);
      this.getScoreList(
        Number(commonAPI.fixYear(this.quarterName)),
        Number(this.computedQuarter),
        this.titleTabindex + 1
      );
    },
    // 季度选择
    tabSwitch(index) {
      if (this.dataTab[index]) {
        this.computedQuarter = commonAPI.fixquarter(this.dataTab[index]);
        this.getScoreList(
          Number(commonAPI.fixYear(this.quarterName)),
          Number(this.computedQuarter),
          this.titleTabindex + 1
        );
      }
    },
    // 地区选择
    titletabChange(index) {
      this.titleTabindex = index;
      this.getScoreList(
        Number(commonAPI.fixYear(this.quarterName)),
        Number(this.computedQuarter),
        index + 1
      );
    },
    fixQuater(index) {
      if (index == 1) {
        return "第一季度";
      } else if (index == 2) {
        return "第二季度";
      } else if (index == 3) {
        return "第三季度";
      } else if (index == 4) {
        return "第四季度";
      }
    },
    // 唤起季度选择组件
    handleQuarterShow() {
      this.$refs.commonPickerQuarter.showPicker();
    },
  },
};
</script>
l<style lang="less" scoped>
.contentOut {
  width: 100%;
  padding: 0 12px;
}
.prov-total {
  margin-top: 24px;

  &-sel {
    display: flex;
    justify-content: space-between;

    .select {
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-right: 4px;
      }

      .select-icon {
        width: 6px;
        height: 4px;
        background: url("../../../assets/image/xiala.png") no-repeat;
        background-size: 6px 4px;
      }
    }

    .search {
      width: 15px;
      height: 15px;
      background: url("../../../assets/image/sousuo.png") no-repeat;
      background-size: 15px 15px;
    }
  }

  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    margin-top: 12px;
    // padding-bottom: 4px;
    &-item {
      display: flex;

      .total {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 24px 0;

        .title {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 12px;

          .icon {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }

        .num {
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(54, 179, 116, 1);
          line-height: 32px;
          margin-top: 9px;
        }

        .compare {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin-top: 8px;

          div:last-child {
            margin-left: 4px;
          }

          .bule {
            color: #2283e6;
          }

          .red {
            color: #ff4d4d;
          }

          .green {
            color: #36b374;
          }
        }
      }

      .total:nth-child(2) {
        border-left: solid 1px #eeeeee;
      }
    }

    &-item:first-child {
      border-bottom: solid 1px #ededed;
    }
    &-item:last-child {
      border-bottom: solid 1px #ededed;
    }
    &-pd16 {
      //   padding: 16px 16px 12px 16px;
      overflow: hidden;
      .mt0 {
        // margin-top: 0;
        margin: 16px 16px 0 16px;
      }

      .mt13 {
        // margin-top: 13px;
        margin: 13px 16px 12px 16px;
      }
    }
    .msg-div {
      //   margin: 15px 16px 0 16px;
      width: 100%;
      padding: 15px 16px 4px 16px;
    }
    .msg-div:last-child {
      margin-bottom: 0;
    }
  }
}
</style>